import React, { useEffect } from 'react';

const PolitiqueConfidentialite: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Politique de Confidentialité | SOS IT Services';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Politique de confidentialité de SOS IT Services — données collectées, finalités, droits RGPD et gestion des cookies.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', 'https://sos-it-services.fr/politique-de-confidentialite');
  }, []);

  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-white mb-2">Politique de Confidentialité</h1>
        <p className="text-sm text-gray-400 mb-10">Dernière mise à jour : 31 mars 2026</p>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">1. Responsable du traitement</h2>
          <p className="text-gray-300 leading-relaxed">
            Le responsable du traitement de vos données personnelles est :
          </p>
          <ul className="mt-3 space-y-1 text-gray-300">
            <li><span className="font-medium">Entreprise :</span> EI Lucas OLIVE</li>
            <li><span className="font-medium">Nom commercial :</span> SOS IT Services</li>
            <li><span className="font-medium">RCS :</span> 883 269 029</li>
            <li><span className="font-medium">Adresse :</span> 485 route de la favorite, 74580 VIRY</li>
            <li>
              <span className="font-medium">Email :</span>{' '}
              <a href="mailto:contact@sos-it-services.fr" className="text-blue-600 hover:underline">
                contact@sos-it-services.fr
              </a>
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">2. Données collectées</h2>
          <p className="text-gray-300 leading-relaxed">
            Dans le cadre de notre activité, nous sommes amenés à collecter les données personnelles
            suivantes :
          </p>
          <ul className="mt-3 list-disc list-inside space-y-1 text-gray-300">
            <li>Nom et prénom, via les formulaires de contact ou de demande de devis</li>
            <li>Adresse e-mail, pour répondre à vos demandes et assurer le suivi</li>
            <li>Numéro de téléphone, si vous le renseignez dans un formulaire</li>
            <li>Données de connexion (identifiant, mot de passe chiffré) si vous créez un compte</li>
            <li>Données de facturation transmises à notre prestataire de paiement</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">3. Finalités du traitement</h2>
          <p className="text-gray-300 leading-relaxed">
            Vos données sont collectées et traitées pour les finalités suivantes :
          </p>
          <ul className="mt-3 list-disc list-inside space-y-1 text-gray-300">
            <li>Fourniture des prestations de services informatiques commandées</li>
            <li>Gestion de la relation client et suivi des tickets de support</li>
            <li>Facturation et tenue de la comptabilité</li>
            <li>Envoi de communications liées à vos demandes ou à votre compte</li>
            <li>Amélioration de nos services grâce à des statistiques d'utilisation anonymisées</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">4. Base légale des traitements</h2>
          <p className="text-gray-300 leading-relaxed">
            Les traitements mis en œuvre reposent sur les bases légales suivantes :
          </p>
          <ul className="mt-3 list-disc list-inside space-y-1 text-gray-300">
            <li>
              <span className="font-medium">Exécution du contrat</span> : traitement nécessaire à la
              réalisation de la prestation commandée
            </li>
            <li>
              <span className="font-medium">Intérêt légitime</span> : amélioration de nos services,
              prévention de la fraude
            </li>
            <li>
              <span className="font-medium">Consentement</span> : dépôt de cookies analytiques,
              communications marketing éventuelles
            </li>
            <li>
              <span className="font-medium">Obligation légale</span> : conservation des pièces
              comptables
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">5. Durée de conservation</h2>
          <p className="text-gray-300 leading-relaxed">
            Vos données personnelles sont conservées pendant la durée nécessaire à l'accomplissement
            des finalités pour lesquelles elles ont été collectées, et au maximum pendant{' '}
            <span className="font-medium">3 ans après la fin de la relation commerciale</span>. Les
            données de facturation sont conservées 10 ans conformément aux obligations légales
            comptables.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">6. Destinataires des données</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Vos données ne sont jamais vendues à des tiers. Elles peuvent être transmises aux
            sous-traitants suivants, dans le strict cadre de leur mission :
          </p>
          <ul className="mt-3 list-disc list-inside space-y-1 text-gray-300">
            <li>
              <span className="font-medium">Stripe</span> : traitement sécurisé des paiements en
              ligne
            </li>
            <li>
              <span className="font-medium">Hostinger</span> : hébergement des données sur des
              serveurs situés dans l'Union Européenne
            </li>
          </ul>
          <p className="mt-3 text-gray-300 leading-relaxed">
            Ces prestataires agissent uniquement sur instruction de SOS IT Services et s'engagent à
            respecter la confidentialité de vos données.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">7. Cookies</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Notre site utilise deux catégories de cookies :
          </p>
          <ul className="mt-3 list-disc list-inside space-y-1 text-gray-300">
            <li>
              <span className="font-medium">Cookies fonctionnels (nécessaires)</span> : indispensables
              au bon fonctionnement du site (session, authentification). Ils ne nécessitent pas votre
              consentement.
            </li>
            <li>
              <span className="font-medium">Cookies analytiques</span> : permettent de mesurer
              l'audience et d'améliorer le site. Ils sont déposés uniquement avec votre consentement,
              recueilli via le bandeau de gestion des cookies.
            </li>
          </ul>
          <p className="mt-3 text-gray-300 leading-relaxed">
            Vous pouvez à tout moment modifier vos préférences en effaçant la clé{' '}
            <code className="bg-gray-700 px-1 rounded text-sm text-gray-200">cookie-consent</code> dans le
            localStorage de votre navigateur.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">8. Vos droits</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des
            droits suivants sur vos données personnelles :
          </p>
          <ul className="mt-3 list-disc list-inside space-y-1 text-gray-300">
            <li><span className="font-medium">Droit d'accès</span> : obtenir une copie de vos données</li>
            <li><span className="font-medium">Droit de rectification</span> : corriger des données inexactes</li>
            <li><span className="font-medium">Droit à l'effacement</span> : demander la suppression de vos données</li>
            <li><span className="font-medium">Droit d'opposition</span> : vous opposer à un traitement</li>
            <li><span className="font-medium">Droit à la portabilité</span> : récupérer vos données dans un format structuré</li>
            <li><span className="font-medium">Droit à la limitation</span> : restreindre le traitement de vos données</li>
          </ul>
          <p className="mt-3 text-gray-300 leading-relaxed">
            Pour exercer ces droits, contactez-nous à{' '}
            <a href="mailto:contact@sos-it-services.fr" className="text-blue-600 hover:underline">
              contact@sos-it-services.fr
            </a>
            . En cas de réponse insatisfaisante, vous pouvez introduire une réclamation auprès de la{' '}
            <a
              href="https://www.cnil.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              CNIL (cnil.fr)
            </a>
            .
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">9. Modifications de la politique</h2>
          <p className="text-gray-300 leading-relaxed">
            Nous nous réservons le droit de modifier la présente politique de confidentialité à tout
            moment, notamment pour nous conformer à l'évolution de la réglementation. La date de
            dernière mise à jour est indiquée en haut de cette page. Nous vous encourageons à la
            consulter régulièrement.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
